import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-sm-flex mb-4" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "row w-100" }
const _hoisted_4 = { class: "col-8 col-lg-6 pt-2" }
const _hoisted_5 = { class: "ticks" }
const _hoisted_6 = { class: "slider d-flex align-items-center w-100" }
const _hoisted_7 = ["id", "min", "max"]
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "text-secondary mb-0" }

import { computed } from "vue";


const __default__ = {
  name: "RangeSlider",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: {
    type: Number,
  },
  label: {
    type: String,
  },
  unit: {
    type: String,
  },
  id: {
    type: String,
  },
  min: {
    type: String,
  },
  max: {
    type: String,
  },
},
  emits: ["update:value"],
  setup(__props, { emit }) {

const props = __props;




const _value = computed({
  get() {
    return props.value;
  },
  set(val) {
    emit("update:value", parseInt(val));
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: __props.id,
      class: "text-secondary w-110 mb-2 text-nowrap"
    }, _toDisplayString(__props.label) + ": ", 9, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.max - __props.min + 1, (i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: i,
              class: "tick"
            }))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            id: __props.id,
            type: "range",
            min: __props.min,
            max: __props.max,
            step: "1",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(_value) ? (_value).value = $event : null))
          }, null, 8, _hoisted_7), [
            [_vModelText, _unref(_value)]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", _hoisted_9, _toDisplayString(__props.value) + " " + _toDisplayString(__props.unit), 1)
      ])
    ])
  ]))
}
}

})